/* global axios */

function gclickUrl() {
  const accountId = window.location.pathname.split('/')[3];
  return `/api/v1/accounts/${accountId}/gclick`;
}

export default {
  show() {
    return axios.get(gclickUrl());
  },

  update(data) {
    return axios.patch(gclickUrl(), data);
  },

  regenerate() {
    return axios.post(`${gclickUrl()}/regenerate`);
  },

  frame() {
    return axios.get(`${gclickUrl()}/frame`);
  },
};
